import Vue from 'vue'
import Router from 'vue-router'
// import Home from '@/views/Home'

// const Home = () =>  import('@/components/Header');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      redirect: '/Home',
      component:() => import('@/views/Home'),
      children: [
        {path: 'Home', name: 'Home', component: () => import('@/views/Home')}
      ]
    },
    {
      path: '/Detail',
      name: 'Detail',
      component: () => import('@/views/Detail'),
      children:[
        //关于毅都
        {
          path: 'About',
          name: 'About',
          redirect: '/Detail/About/GeneralIntroduction',
          component: () => import('@/views/AboutYIDU/About'),
          children:[
            {path: 'GeneralIntroduction',name: 'GeneralIntroduction', component: () => import('@/views/AboutYIDU/GeneralIntroduction')},
            {path: 'Culture', name: 'Culture', component: () => import('@/views/AboutYIDU/Culture')},
            {path: 'Honor', name: 'Honor', component: () => import('@/views/AboutYIDU/Honor')},
            {path: 'History', name: 'History', component: () => import('@/views/AboutYIDU/History')},
            {path: 'YIDUVideo', name: 'YIDUVideo', component: () => import('@/views/AboutYIDU/YIDUVideo')}
          ]
        },
        //毅都资讯
        {
          path: 'PressCenter',
          name: 'PressCenter',
          redirect: '/Detail/PressCenter/YIDUEvents',
          component: () => import('@/views/PressCenter/PressCenter'),
          children:[
            {path: 'YIDUEvents', name: 'YIDUEvents', component: () => import('@/views/PressCenter/YIDUEvents')},
            {path: 'IndustryNews', name: 'IndustryNews', component: () => import('@/views/PressCenter/IndustryNews')},
            {path: 'EnterpriseJournal', name: 'EnterpriseJournal', component: () => import('@/views/PressCenter/EnterpriseJournal')},
          ]
        },
        //业务涵盖
        {
          path: 'BusinessLine',
          name: 'BusinessLine',
          redirect: '/Detail/BusinessLine/ImportAndExportTrade/SelectFromSource',
          component: () => import('@/views/BusinessLine/BusinessLine'),
          children:[
            {
              path: 'ImportAndExportTrade',
              name: 'ImportAndExportTrade',
              redirect: '/Detail/BusinessLine/ImportAndExportTrade/SelectFromSource',
              component: () => import('@/views/BusinessLine/ImportAndExportTrade'),
              children:[
                  {
                    path: 'SelectFromSource',
                    name: 'SelectFromSource',
                    component: () => import('@/views/BusinessLine/ImportAndExportTrade/SelectFromSource'),
                  },{
                    path: 'DomesticSales',
                    name: 'DomesticSales',
                    component: () => import('@/views/BusinessLine/ImportAndExportTrade/DomesticSales'),

                  },{
                    path: 'ProductDisplay',
                    name: 'ProductDisplay',
                    component: () => import('@/views/BusinessLine/ImportAndExportTrade/ProductDisplay'),
                  }
              ]
            },
            {
              path: 'ColdChainLogistics',
              name: 'ColdChainLogistics',
              redirect: '/Detail/BusinessLine/ColdChainLogistics/SeafoodColdChianBU',
              component: () => import('@/views/BusinessLine/ColdChainLogistics'),
              children:[
                {
                  path: 'SeafoodColdChianBU',
                  name: 'SeafoodColdChianBU',
                  component: () => import('@/views/BusinessLine/ColdChainLogistics/SeafoodColdChianBU'),
                },{
                  path: 'MeatServiceBU',
                  name: 'MeatServiceBU',
                  component: () => import('@/views/BusinessLine/ColdChainLogistics/MeatServiceBU'),

                },{
                  path: 'FruitTradingServiceBU',
                  name: 'FruitTradingServiceBU',
                  component: () => import('@/views/BusinessLine/ColdChainLogistics/FruitTradingServiceBU'),
                },{
                  path: 'SupplyChainServices',
                  name: 'SupplyChainServices',
                  component: () => import('@/views/BusinessLine/ColdChainLogistics/SupplyChainServices'),
                },{
                  path: 'DistributionServices',
                  name: 'DistributionServices',
                  component: () => import('@/views/BusinessLine/ColdChainLogistics/DistributionServices'),
                },{
                  path: 'RefrigeratedBoxTechnicalServices',
                  name: 'RefrigeratedBoxTechnicalServices',
                  component: () => import('@/views/BusinessLine/ColdChainLogistics/RefrigeratedBoxTechnicalServices'),

                },{
                  path: 'SupplyChainFinancialServices',
                  name: 'SupplyChainFinancialServices',
                  component: () => import('@/views/BusinessLine/ColdChainLogistics/SupplyChainFinancialServices'),
                },{
                  path: 'NationalLayouts',
                  name: 'NationalLayouts',
                  component: () => import('@/views/BusinessLine/ColdChainLogistics/NationalLayouts'),
                }
              ]
            },
            {
              path: 'EcologicalAgricultures',
              name: 'EcologicalAgricultures',
              redirect: '/Detail/BusinessLine/EcologicalAgricultures/IndustryIntroduction',
              component: () => import('@/views/BusinessLine/EcologicalAgricultures'),
              children:[
                {
                  path: 'IndustryIntroduction',
                  name: 'IndustryIntroduction',
                  component: () => import('@/views/BusinessLine/EcologicalAgricultures/IndustryIntroduction'),
                },
                {
                  path: 'BaseProfile',
                  name: 'BaseProfile',
                  component: () => import('@/views/BusinessLine/EcologicalAgricultures/BaseProfile'),
                }
              ]
            }
            // {path: 'EcologicalAgriculture1', name: 'EcologicalAgriculture1', component: () => import('@/views/BusinessLine/EcologicalAgriculture')},
          ]
        },

        //加入毅都
        {
          path: 'JoinYIDU',
          name: 'JoinYIDU',
          redirect: '/Detail/JoinYIDU/CampusRecruitment/ManagementTraineeProgram',
          component: () => import('@/views/JoinYIDU/JoinYIDU'),
          children:[
            {
              path: 'CampusRecruitment',
              name: 'CampusRecruitment',
              redirect: '/Detail/JoinYIDU/CampusRecruitment/ManagementTraineeProgram',
              component: () => import('@/views/JoinYIDU/CampusRecruitment'),
              children:[
                {
                  path: 'ManagementTraineeProgram',
                  name: 'ManagementTraineeProgram',
                  component: () => import('@/views/JoinYIDU/CampusRecruitment/ManagementTraineeProgram'),
                },{
                  path: 'JobDescription',
                  name: 'JobDescription',
                  component: () => import('@/views/JoinYIDU/CampusRecruitment/JobDescription.vue'),

                },{
                  path: 'CampusRecruitmentProcess',
                  name: 'CampusRecruitmentProcess',
                  component: () => import('@/views/JoinYIDU/CampusRecruitment/CampusRecruitmentProcess.vue'),
                }
              ]
            },
            {path: 'SocialRecruitment', name: 'SocialRecruitment', component: () => import('@/views/JoinYIDU/SocialRecruitment')},
            {path: 'YIDUPeople', name: 'YIDUPeople', component: () => import('@/views/JoinYIDU/YIDUPeople')},
          ]
        },

        //联系我们
        {
          path: 'ContactUs',
          name: 'ContactUs',
          // redirect: '/ContactUs',
          component: () => import('@/views/ContactUs/ContactUs'),
          // children:[
          //   {path: 'ContactUs', name: 'ContactUs', component: () => import('@/views/ContactUs/ContactUs')},
          // ]
        }
      ]
    },
  ],
  // scrollBehavior(to, from, savedPosition) {
  //   // if(savedPosition && from.matched[3].name !== to.matched[3].name){
  //   //   return savedPosition
  //   // }
  //   //   to.path.includes(from.matched[1].name)
  //   // if(from.name ==='Home' && ( to.path.includes('BusinessLine') || to.path.includes('PressCenter')  ) ){
  //   //   return {x: 0, y: 200 }
  //   // }
  //
  //   // return {x: 0, y: 0 }
  // },

})
// router.beforeEach((to, from, next) => {
//   console.log(to.name,from.name)
//   next()
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js